/**
 * JPEG (and other lossy formats) carry no alpha channel: without an opaque
 * backdrop, transparent source pixels (e.g. a transparent PNG) composite to
 * black on encode. Fill white first for any non-PNG target — before
 * `drawImage` — so the output matches the PNG-preserved variant instead of
 * going black-backed. No-op for PNG, which keeps its transparency.
 *
 * Single home for this canvas-encode rule so every encode site (the image
 * cropper particle and consumer-side photo processing) cannot drift on a fix.
 */
export function fillOpaqueBackdropForLossy(
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  type: string,
): void {
  if (type === "image/png") return;
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, width, height);
}
